import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  FormGroup,
  FormControl,
  ControlLabel
} from 'react-bootstrap'
import {
  LeftSidebarView,
  ViewBody
} from 'components/Sidebar'
import Toggle from 'components/Toggle'
import * as ActivityDetailLevel from 'const/ActivityDetailLevel'

export class Notifications extends React.Component {
  static propTypes = {
    settings: PropTypes.object.isRequired,

    requestChangeUserSettings: PropTypes.func.isRequired
  }

  static DETAIL_LEVELS = [
    {
      id: ActivityDetailLevel.ALL,
      formattedMessageId: 'ACTIVITY_DETAIL_LEVEL_ALL'
    },
    {
      id: ActivityDetailLevel.IMPORTANT,
      formattedMessageId: 'ACTIVITY_DETAIL_LEVEL_IMPORTANT'
    },
    {
      id: ActivityDetailLevel.COMMENTS,
      formattedMessageId: 'ACTIVITY_DETAIL_LEVEL_COMMENTS'
    }
  ]

  handleNotificationDetailLevelChange = (event) => {
    this.props.requestChangeUserSettings({
      notificationsDetailLevel: +event.target.value
    })
  }

  handleNotificationSoundChange = (value) => {
    this.props.requestChangeUserSettings({
      notificationSound: value
    })
  }

  handleNotificationOccurenceChange = (event) => {
    this.props.requestChangeUserSettings({
      notificationOccurence: +event.target.value
    })
  }

  render () {
    const {
      settings
    } = this.props

    return (
      <LeftSidebarView
        title={<FormattedMessage id='USER_SETTINGS_NOTIFICATION' />}
      >
        <ViewBody>
          <FormGroup controlId='notificationDetailLevel'>
            <ControlLabel>
              <FormattedMessage id='ACTIVITY_DETAIL_LEVEL' />
            </ControlLabel>
            <FormControl
              componentClass='select'
              value={settings.notificationsDetailLevel}
              onChange={this.handleNotificationDetailLevelChange}
            >
              {Notifications.DETAIL_LEVELS.map(detailLevel =>
                <FormattedMessage key={detailLevel.id} id={detailLevel.formattedMessageId}>
                  {(formattedMessage) => (
                    <option value={detailLevel.id}>{formattedMessage}</option>
                  )}
                </FormattedMessage>
              )}
            </FormControl>
          </FormGroup>
          <FormGroup controlId='notificationOccurence'>
            <ControlLabel><FormattedMessage id='USER_SETTINGS_NOTIFICATION_OCCURENCE' /></ControlLabel>
            <FormControl
              componentClass='select'
              value={settings.notificationOccurence}
              onChange={this.handleNotificationOccurenceChange}
            >
              {[
                { messageId: 'USER_SETTINGS_NOTIFICATION_OCCURENCE_NONE', value: '0' },
                { messageId: 'USER_SETTINGS_NOTIFICATION_OCCURENCE_15M', value: '1' },
                { messageId: 'USER_SETTINGS_NOTIFICATION_OCCURENCE_1H', value: '4' },
                { messageId: 'USER_SETTINGS_NOTIFICATION_OCCURENCE_24H', value: '96' }
              ].map(occurence =>
                <FormattedMessage key={occurence.value} id={occurence.messageId}>
                  {(formattedMessage) => (
                    <option value={occurence.value}>{formattedMessage}</option>
                  )}
                </FormattedMessage>
              )}
            </FormControl>
          </FormGroup>
          <FormGroup controlId='notificationSound'>
            <ControlLabel><FormattedMessage id='USER_SETTINGS_NOTIFICATION_SOUND' /></ControlLabel>
            <div>
              <Toggle
                checked={settings.notificationSound}
                onChange={this.handleNotificationSoundChange}
              />
            </div>
          </FormGroup>
        </ViewBody>
      </LeftSidebarView>
    )
  }
}

export default Notifications
